define.alias("ember-truth-helpers/helpers/lt", "media/helpers/lt");